import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Polls /presence for a set of user ids and returns an { id: boolean } map of
// who is currently online (last_seen within the backend's 120s window).
export function usePresence(ids) {
  const [online, setOnline] = useState({});
  const key = (ids || []).filter(Boolean).slice(0, 50).join(',');
  const keyRef = useRef(key);
  keyRef.current = key;

  useEffect(() => {
    if (!key) { setOnline({}); return; }
    let active = true;
    const fetchPresence = async () => {
      try {
        const { data } = await axios.get(`${API}/presence`, { params: { ids: keyRef.current }, withCredentials: true });
        if (active) setOnline(data.online || {});
      } catch (e) { /* not logged in or transient — ignore */ }
    };
    fetchPresence();
    const t = setInterval(fetchPresence, 30000);
    return () => { active = false; clearInterval(t); };
  }, [key]);

  return online;
}

export default usePresence;
